<template>
  <div>
    <v-dialog v-model="edit" max-width="700px">
      <edit-driver :driver="driver" @close="edit = false"></edit-driver>
    </v-dialog>
    <v-list-tile avatar ripple @click="edit = true">
      <v-list-tile-avatar :color="color">
        <span class="white--text">{{letter.toUpperCase()}}</span>
      </v-list-tile-avatar>

      <v-list-tile-content>
        <v-list-tile-title class>{{driver.name}}</v-list-tile-title>
        <v-list-tile-sub-title class>
          <span class="text--primary">{{driver.contractor.name}}</span>
          &mdash; {{driver.contractor.contactEmail}}
        </v-list-tile-sub-title>
      </v-list-tile-content>
      <v-list-tile-action>
        <slot name="action"></slot>
      </v-list-tile-action>
    </v-list-tile>
    <v-divider inset></v-divider>
  </div>
</template>

<script>
import getColorFromChar from "@/services/helpers/getColorFromChar";
import EditDriver from "@/components/drivers/editDriver";
export default {
  data() {
    return {
      edit: false
    };
  },
  methods: {
    clickDriver() {
      //console.log("sasd");
    }
  },
  props: {
    driver: Object
  },
  computed: {
    color() {
      return getColorFromChar(this.driver.name.charCodeAt(0));
    },
    letter() {
      return this.driver.name.charAt(0);
    }
  },
  components: {
    EditDriver
  }
};
</script>

<style>
</style>
